import { Box, Grid2 as Grid, Link, Typography } from '@mui/material'
import ContentModal from 'components/ContentModal'
import LogoSa from 'assets/logo_sa_minimal.svg?react'
import { SA_WEBSITE } from 'consts'
import { useLogoSaWrapperStyles } from 'components/SaLogo'

interface IAboutUsModalProps {
  isOpen: boolean
  setIsOpen: () => void
}

export const AboutUsModal: React.FC<IAboutUsModalProps> = ({
  isOpen,
  setIsOpen
}) => {
  const logoSaWrapperStyle = useLogoSaWrapperStyles(true)
  return (
    <ContentModal
      open={isOpen}
      title='Sobre nós'
      onConfirm={setIsOpen}
      sx={{ width: 500 }}
    >
      <Grid container spacing={2}>
        <Grid size={12}>
          <Box sx={logoSaWrapperStyle}>
            <LogoSa width={150} />
          </Box>
        </Grid>
        <Grid size={12}>
          <Typography variant='h4'>swissanalytica</Typography>
        </Grid>
        <Grid size={12}>
          Inovamos no cuidado à saúde, capacitando médicos e aprimorando os
          desfechos clínicos dos pacientes por meio de soluções inteligentes e
          eficazes.
        </Grid>
        <Grid size={12}>
          <Link href={SA_WEBSITE} target='_blank'>
            Ver website
          </Link>
        </Grid>
      </Grid>
    </ContentModal>
  )
}
